import { render } from "./SectionComp.vue?vue&type=template&id=0786e6ae"
import script from "./SectionComp.vue?vue&type=script&lang=js"
export * from "./SectionComp.vue?vue&type=script&lang=js"

import "./SectionComp.vue?vue&type=style&index=0&id=0786e6ae&lang=css"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__